export default {
      id: "icon-kisisel-dolap-usage",
      viewBox: "0 0 507.4 507.4",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-kisisel-dolap",
      toString: function () {
        return this.url;
      }
    }